import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import { UserDataContext } from './Context';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateToken, useNotify } from './Utils';
import { Button } from '@mui/material';

export default function AccountMenu() {
  const navigate = useNavigate()  
  const [userData] = useContext(UserDataContext)
  const notify = useNotify()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


    const logout = async () => {
    try {
      const token =  await validateToken({userData})
      
      const fetchToLogout =  await  fetch(`${process.env.REACT_APP_API_URL}/logoutuser`,
      {
        "method": "POST",
        "credentials": "include",
        "headers": {
          "Authorization": `Bearer ${token}`,
        }
      })
      const jsonresp =   await fetchToLogout.json()
      if (fetchToLogout.ok) {

        notify({message: jsonresp,variant: "success",duration: 1000,horizontal:"right"});
        navigate("/")
      }
      else {
        notify({message: jsonresp,variant: "warning",duration: 2000,});
      }
      }
    catch (error) {
      console.log(error)
      notify({message: "cant sync with server please try again later",variant: "error",duration:2000})
      
      return
      }
    }
  
  
  


  

  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
     
        <Tooltip title="Account">
          <Button
            // variant='outlined' 
            onClick={handleClick}
            size="small"
            sx={{ ml: 2,textTransform: 'none' }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            
          >
            
            
              Welcome, {userData.username}
            
            
          </Button>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        
        <MenuItem onClick={() => navigate("/account")}sx={{width: 150}}>
        <Avatar  sx={{ width: 24, height: 24, textAlign: "center" }}>{userData.username?.[0]}</Avatar>
        Account
        </MenuItem>
        <Divider />
        
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
